import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <header className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden bg-navy-900" data-id="element-132">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-133">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-navy-800 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-134" />
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-gold-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000" data-id="element-135" />
      </div>

      <div className="relative max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-left space-y-8" data-id="element-137">
          <div className="space-y-4" data-id="element-138">
            <motion.span initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="inline-block text-gold-400 font-medium tracking-wider uppercase text-sm" data-id="element-139">
              Para Mujeres de 40+
            </motion.span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-medium leading-tight text-cream-50" data-id="element-140">
              Detén el <br data-id="element-141" />
              <span className="text-gold-400 italic" data-id="element-142">Patrón de las 2–4am.</span>
            </h1>
            <p className="text-xl md:text-2xl text-cream-100/80 font-light max-w-lg" data-id="element-143">
              Una rutina nocturna de 4 pasos para recuperar tu sueño sin
              medicamentos ni misticismo.
            </p>
          </div>

          <div className="space-y-6" data-id="element-144">
            <p className="text-lg text-cream-100/70 leading-relaxed" data-id="element-145">
              Estás agotada todo el día. Pero en el momento en que tu cabeza
              toca la almohada… tu cerebro actúa como si fichara para el turno
              de noche. Es hora de cerrar el ciclo.
            </p>
            <Button onClick={() => document.getElementById('cta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-146">
              Obtener El Libro Digital
            </Button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative" data-id="element-147">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-navy-900/50 border border-navy-700/50" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/wKFgBSYtCjCnjAkjTNtBBK/heylloyd-image-1771466099503.png" alt="El Libro Digital Sueño y Serenidad en una tablet en un ambiente acogedor" className="w-full h-auto object-cover" data-id="element-149" />
          </div>
          {/* Decorative ring */}
          <div className="absolute -inset-4 border border-gold-500/20 rounded-3xl z-0" data-id="element-150" />
        </motion.div>
      </div>
    </header>;
}